export default {
  GET_INTERNAL_COLUMNS_REQUEST: '@@internal-columns/GET_INTERNAL_COLUMNS_REQUEST',
  GET_INTERNAL_COLUMNS_SUCCESS: '@@internal-columns/GET_INTERNAL_COLUMNS_SUCCESS',
  GET_INTERNAL_COLUMNS_ERROR: '@@internal-columns/GET_INTERNAL_COLUMNS_ERROR',

  FLUSH_INTERNAL_COLUMNS_ALL_STATE: '@@internal-columns/FLUSH_INTERNAL_COLUMNS_ALL_STATE',
};
